import { TBasicModel } from './types';

export const basicInitialState: TBasicModel = {
  error: null,
  isPending: false,
};
